module.exports = __webpack_public_path__ + "static/media/final-touches.8d2bd5c8.png";